import { render, staticRenderFns } from "./DashboardCardContainer.vue?vue&type=template&id=51a2bd9a&"
import script from "./DashboardCardContainer.vue?vue&type=script&lang=js&"
export * from "./DashboardCardContainer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCardContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports